<template>
  <div id="login-main" class="cyber-auth-wrapper">
    <!-- Animated background grid -->
    <div class="cyber-grid"></div>
    <!-- Floating particles -->
    <div class="cyber-particles">
      <div class="particle" v-for="n in 6" :key="n" :class="'p-' + n"></div>
    </div>
    <div class="cyber-auth-container">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    document.body.className = "hold-transition login-page cyber-login-page";
    document.querySelector("#login-main").parentElement.className = "login-box cyber-login-box";
  },
  destroyed() {
    document.querySelector("#main").className = "";
  },
};
</script>

<style lang="scss">
.cyber-login-page {
  background: #1a1a1a !important;
  min-height: 100vh;
  overflow: hidden;
}

.cyber-login-box {
  position: relative;
  max-width: 440px;
  width: 100%;
  margin: 0 auto;
  z-index: 2;
  height: auto !important;
  padding: 20px !important;
}

.cyber-auth-wrapper {
  position: relative;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.cyber-auth-container {
  position: relative;
  z-index: 2;
  width: 100%;
}

/* Animated grid background */
.cyber-grid {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  background-image:
    linear-gradient(rgba(176, 154, 78, 0.03) 1px, transparent 1px),
    linear-gradient(90deg, rgba(176, 154, 78, 0.03) 1px, transparent 1px);
  background-size: 60px 60px;
  animation: gridMove 20s linear infinite;
}

@keyframes gridMove {
  0% { transform: perspective(500px) rotateX(60deg) translateY(0); }
  100% { transform: perspective(500px) rotateX(60deg) translateY(60px); }
}

/* Floating particles */
.cyber-particles {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 1;
}

.particle {
  position: absolute;
  border-radius: 50%;
  animation: float linear infinite;
}

.p-1 {
  width: 4px; height: 4px;
  background: rgba(176, 154, 78, 0.6);
  top: 20%; left: 15%;
  animation-duration: 8s;
  box-shadow: 0 0 10px rgba(176, 154, 78, 0.4);
}
.p-2 {
  width: 3px; height: 3px;
  background: rgba(123, 191, 181, 0.5);
  top: 60%; left: 80%;
  animation-duration: 12s;
  animation-delay: -3s;
  box-shadow: 0 0 8px rgba(123, 191, 181, 0.3);
}
.p-3 {
  width: 5px; height: 5px;
  background: rgba(176, 154, 78, 0.4);
  top: 80%; left: 30%;
  animation-duration: 10s;
  animation-delay: -5s;
  box-shadow: 0 0 12px rgba(176, 154, 78, 0.3);
}
.p-4 {
  width: 2px; height: 2px;
  background: rgba(123, 191, 181, 0.6);
  top: 30%; left: 70%;
  animation-duration: 9s;
  animation-delay: -2s;
}
.p-5 {
  width: 3px; height: 3px;
  background: rgba(176, 154, 78, 0.5);
  top: 50%; left: 50%;
  animation-duration: 11s;
  animation-delay: -7s;
  box-shadow: 0 0 8px rgba(176, 154, 78, 0.3);
}
.p-6 {
  width: 4px; height: 4px;
  background: rgba(123, 191, 181, 0.4);
  top: 10%; left: 90%;
  animation-duration: 14s;
  animation-delay: -4s;
}

@keyframes float {
  0% { transform: translateY(0) translateX(0); opacity: 0; }
  10% { opacity: 1; }
  90% { opacity: 1; }
  100% { transform: translateY(-100vh) translateX(30px); opacity: 0; }
}
</style>
